const doc = [({"da":({"js":({"admin":({"contacts":({"show":({"uni_c":({"organization_relations":"Organisationrelationer", "data":"Data"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;